import api from "../Api";
import routes from "../constants/ApiRoutesConstants";

export async function PatchUserPassword(formData) {
  const jsonData = Object.fromEntries(formData.entries());

  const res = await api.patch(routes.CHANGE_PASSWORD, jsonData);

  return res;
}
